import React, { useState } from 'react';
import { AsyncPaginate } from 'react-select-async-paginate';
import { useUserGroup } from '../contexts/UserGroupContext';
import { CFormLabel } from '@coreui/react';

function UserGroupSelection({ value, onChange, className, labelClassName, multiSelect = true, required = false, error = false, isDisabled=false }) {
    const requiredIcon = required ? <span className="text-danger">*</span> : null;

    const { getAllUserGroups } = useUserGroup();

    const [totalRenderedRecords, setTotalRenderedRecords] = useState(0)
    const [filter, setFilter] = useState({
        limit: 50,
        totalRenderedRecords: totalRenderedRecords,
        filter: null
    });

    const fetchUserGroup = async (searchValue, loadedOptions, { totalRenderedRecords }) => {
        try {
            const response = await getAllUserGroups({ ...filter, filter: searchValue, totalRenderedRecords });

            if (response.totalPages > 0) {
                const newOptions = response.userGroups.length > 0 && response.userGroups.map((userGroup) => ({
                    label: userGroup.name,
                    value: userGroup.id,
                }));

                const hasMore = totalRenderedRecords + newOptions.length < response.totalCount;

                return {
                    options: newOptions,
                    hasMore: hasMore,
                    additional: {
                        totalRenderedRecords: totalRenderedRecords + filter.limit,
                    },
                };
            } else {
                return {
                    options: [],
                    hasMore: false,
                    additional: null,
                };
            }
        } catch (error) {
            console.error('Error fetching user groups', error);
            return {
                options: [],
                hasMore: false,
                additional: null,
            };
        }
    };

    const customStyles = {
        option: (provided, state) => ({
            ...provided,
            whiteSpace: state.isFocused ? 'pre-wrap' : 'nowrap',
            wordBreak: state.isFocused ? 'break-all' : null,
            wordWrap: state.isFocused ? 'break-word' : null,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
        }),
    };

    return (
        <div className={className}>
            <div className={labelClassName}>
                <CFormLabel>User Group {requiredIcon}</CFormLabel>
            </div>
            <div className='w-100'>
                <AsyncPaginate
                    className={`${(error && required) && 'multiSelect_error'} `}
                    value={value}
                    loadOptions={fetchUserGroup}
                    isMulti={multiSelect}
                    closeMenuOnSelect={!multiSelect ? true : false}
                    onChange={onChange}
                    placeholder='Select user group...'
                    noOptionsMessage={() => ('No user groups found')}
                    loadingMessage={() => ('User Groups Loading...')}
                    additional={{
                        totalRenderedRecords: totalRenderedRecords,
                    }}
                    SelectProps={{
                        isSearchable: true,
                    }}
                    menuShouldScrollIntoView={false}
                    menuPortalTarget={document.querySelector('body')}
                    styles={customStyles}
                    isDisabled={isDisabled}
                />
                {(error && required) && <span className="text-danger error_message">Please select any one user group.</span>}
            </div>
        </div>
    );
}

export default UserGroupSelection